import React,{useRef,useState} from 'react'
import {Link,useHistory} from 'react-router-dom'
import {useAuth} from './AuthContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope,faLock } from '@fortawesome/free-solid-svg-icons'
import swal from 'sweetalert'
import './Main.css'



export default function Login() {
	const emailRef=useRef();
    const passwordRef=useRef();
    const {login} =useAuth()
    const [error,setError]=useState();
	const [loding,setLoading]=useState(false);
	const history=useHistory()
	async function handleSubmit(e){
        e.preventDefault();
        try{
            setError('')
            setLoading(true)
            await login(emailRef.current.value,passwordRef.current.value)
            history.push("./")
        }catch (err){
			setError(err.message)
			swal({
                title:err.message,
                text:"enter valid mail or password",
                icon:"warning",
                button:"ok",
			})
			
        }
        setLoading(false)
    }

    return (
		<section>
			<div id="container"></div>
			
				<div id="subcontainer">
					
						<form>
						<h2 > LOG IN</h2>
						<div id="hul"></div>
							<div className="inputbox">
								
								<input type="email" ref={emailRef} placeholder="E-mail" required></input>
								<span class="focus-input100"></span>
								<span class="symbol-input10">
								<FontAwesomeIcon icon={faEnvelope} />
								</span>
								
							</div>
							<div className="inputbox">
								<input type="password" placeholder="password" ref={passwordRef} required></input>
								<span class="focus-input100"></span>
								<span class="symbol-input100">
								<FontAwesomeIcon icon={faLock} />
								</span>
							</div>
							<div className="inputbox">
								<button disabled={loding} onClick={handleSubmit}> Log in </button>
							</div>
							<p>Forget Password ? <Link to="./resetpassword">Reset</Link></p>
							<p>Dont have account <Link to="/signup">Signup</Link></p>
						</form>
			</div>
		</section>

     
    )
}
